import { IPTC_DIGITAL_SOURCE_TYPE_COMPOSITE_SYNTHETIC } from "./constants";

/**
 * Build a minimal XMP packet asserting IPTC `DigitalSourceType =
 * compositeSynthetic` — our exported ads composite AI-generated imagery with
 * non-AI elements (copy, shapes, brand assets). Embedded into exported image
 * files (an `iTXt` chunk for PNGs) so platforms and tools that read provenance
 * metadata can identify the AI involvement.
 */
export function buildAiDisclosureXmp(): string {
  return [
    `<?xpacket begin="﻿" id="W5M0MpCehiHzreSzNTczkc9d"?>`,
    `<x:xmpmeta xmlns:x="adobe:ns:meta/">`,
    `  <rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">`,
    `    <rdf:Description rdf:about="" xmlns:Iptc4xmpExt="http://iptc.org/std/Iptc4xmpExt/2008-02-29/">`,
    `      <Iptc4xmpExt:DigitalSourceType>${IPTC_DIGITAL_SOURCE_TYPE_COMPOSITE_SYNTHETIC}</Iptc4xmpExt:DigitalSourceType>`,
    `    </rdf:Description>`,
    `  </rdf:RDF>`,
    `</x:xmpmeta>`,
    `<?xpacket end="w"?>`,
  ].join("\n");
}
